import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "value", "type", "inputmode", "placeholder", "autocomplete", "aria-describedby", "aria-invalid", "required"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseInput',
    props: {
        modelValue: {},
        id: { default: undefined },
        type: { default: "text" },
        placeholder: { default: "" },
        inputmode: { default: "text" },
        variant: { default: "default" },
        ariaDescribedby: { default: undefined },
        invalid: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        autocomplete: { default: undefined }
    },
    emits: ["update:modelValue", "blur"],
    setup(__props, { emit: __emit }) {
        // SYNC: see ../../_SYNC.md.
        const emit = __emit;
        function onInput(event) {
            emit("update:modelValue", event.target.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("input", {
                id: __props.id,
                class: _normalizeClass(["df-input", { 'df-input--amount': __props.variant === 'amount', 'df-input--error': __props.invalid }]),
                value: __props.modelValue,
                type: __props.type,
                inputmode: __props.inputmode,
                placeholder: __props.placeholder,
                autocomplete: __props.autocomplete,
                "aria-describedby": __props.ariaDescribedby,
                "aria-invalid": __props.invalid ? true : undefined,
                required: __props.required,
                onInput: onInput,
                onBlur: _cache[0] || (_cache[0] = ($event) => (emit('blur')))
            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1));
        };
    }
});
